import { render, staticRenderFns } from "./GiftPickerAppearance.vue?vue&type=template&id=2c03e152&"
import script from "./GiftPickerAppearance.vue?vue&type=script&lang=js&"
export * from "./GiftPickerAppearance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports